var _path, _g, _path2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivateBlokLogoChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.39,
    height: 24.2,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_211_11131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4924 0.107638L0.724311 12.4335C0.493708 12.4977 0.294311 12.6425 0.162868 12.841C0.0314242 13.0395 -0.0232064 13.2784 0.00904399 13.5137C0.0412944 13.749 0.158252 13.9649 0.338363 14.1214C0.518473 14.278 0.749597 14.3647 0.989139 14.3657L29.2383 14.1714C29.854 14.1655 30.4647 14.281 31.0349 14.5113C31.6051 14.7416 32.1233 15.082 32.5596 15.5127C32.9958 15.9434 33.3412 16.4559 33.5758 17.0202C33.8103 17.5845 33.9293 18.1895 33.9257 18.7998L33.788 43.0235C33.79 43.2624 33.8795 43.4924 34.0398 43.6707C34.2002 43.849 34.4204 43.9634 34.6596 43.9926C34.8987 44.0218 35.1404 43.9639 35.3396 43.8295C35.5389 43.6952 35.682 43.4937 35.7425 43.2624L47.9086 3.43653C48.016 3.0331 48.0289 2.6107 47.9465 2.20156C47.864 1.79243 47.6883 1.40738 47.4328 1.07584C47.1773 0.74429 46.8487 0.475007 46.4722 0.288552C46.0957 0.102097 45.6812 0.00340065 45.2604 0C45.0015 0.0006183 44.7439 0.0368428 44.495 0.107638",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_211_11131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3854 0H-0.387939V44.3729H48.3854V0Z",
    fill: "url(#paint0_linear_211_11131)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_211_11131",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 18,
    width: 16,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.765 28.8232C17.9915 28.0754 17.5041 27.0845 17.3861 26.0199C17.2682 24.9553 17.5269 23.8832 18.1181 22.9868C18.7093 22.0904 19.5963 21.4254 20.6274 21.1056C21.6585 20.7858 22.7696 20.831 23.7708 21.2335C24.772 21.6359 25.601 22.3707 26.1162 23.3121C26.6313 24.2535 26.8006 25.343 26.595 26.3945C26.3895 27.4459 25.8218 28.3939 24.9892 29.0764C24.1566 29.7588 23.1106 30.1333 22.0303 30.1358C20.8105 30.1387 19.6382 29.6674 18.765 28.8232ZM28.267 18.4952L15.6638 18.6107C15.5669 18.6114 15.4711 18.6311 15.3819 18.6686C15.2926 18.706 15.2117 18.7606 15.1438 18.8291C15.0759 18.8977 15.0223 18.9788 14.9861 19.068C14.95 19.1571 14.9319 19.2524 14.9329 19.3485L15.0494 31.8423C15.0505 31.9381 15.0705 32.0328 15.1085 32.121C15.1465 32.2092 15.2016 32.289 15.2707 32.3561C15.3398 32.4231 15.4215 32.476 15.5112 32.5117C15.601 32.5474 15.6969 32.5653 15.7936 32.5643L28.3967 32.4487C28.4934 32.4474 28.5889 32.4271 28.6777 32.3892C28.7665 32.3512 28.8469 32.2963 28.9142 32.2276C28.9816 32.1588 29.0347 32.0776 29.0704 31.9885C29.1061 31.8994 29.1238 31.8043 29.1224 31.7084L29.0058 19.2146C29.0044 19.0219 28.9263 18.8376 28.7883 18.7019C28.6504 18.5662 28.464 18.49 28.2696 18.49",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_211_11131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1302 18.49H14.9275V32.5643H29.1302V18.49Z",
    fill: "url(#paint1_linear_211_11131)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_211_11131",
    x1: 1.66054,
    y1: 22.1865,
    x2: 55.7989,
    y2: 22.1865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05ABB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#05ABB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3366FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_211_11131",
    x1: 15.524,
    y1: 25.5271,
    x2: 31.289,
    y2: 25.5271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05ABB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#05ABB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3366FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateBlokLogoChat);
export default __webpack_public_path__ + "static/media/PrivateBlokLogoChat.13e05889c05d2d4b43496ae19fa9aa21.svg";
export { ForwardRef as ReactComponent };